/**
 * Intervalos de polling do módulo de suporte.
 *
 * Não existe WebSocket no projeto — é o `refetchInterval` do react-query que
 * faz a conversa parecer viva. Os três valores são deliberadamente diferentes
 * porque respondem a perguntas diferentes.
 */

/**
 * Chat aberto. Mesmo valor (e mesmo motivo) do chat de discussões técnicas: 2s
 * é o limite abaixo do qual a conversa deixa de parecer conversa.
 */
export const INTERVALO_CHAT_MS = 2_000;

/** Lista e fila não precisam parecer ao vivo — precisam estar atualizadas. */
export const INTERVALO_LISTA_MS = 15_000;

/**
 * Badge do botão flutuante e da sidebar. É ambiente, não conversa: 30s é
 * imperceptível e quase de graça.
 */
export const INTERVALO_BADGE_MS = 30_000;

/** Lista curta dentro do painel do botão flutuante — só enquanto ele está aberto. */
export const INTERVALO_PAINEL_MS = 5_000;

/** Quantos chamados recentes o painel do botão flutuante mostra. */
export const CHAMADOS_NO_PAINEL = 5;

/**
 * Altura do botão flutuante + respiro, em px. Usado para posicionar o painel
 * logo acima dele.
 */
export const ALTURA_DO_BOTAO_PX = 56;

/**
 * Quantas mensagens a conversa de um chamado carrega. TEM que respeitar o
 * `TETO_POR_PAGINA` do backend (100): acima disso a API responde 422 e a
 * conversa aparece vazia. Busca-se em ordem `desc` e inverte-se na tela, para
 * que um chamado com mais mensagens que isso mostre as MAIS RECENTES.
 */
export const MENSAGENS_NA_CONVERSA = 100;
